// extracted by mini-css-extract-plugin
export var copyableField = "_rc-4";
export var customerBadge = "_rc-0";
export var customerInfoTitle = "_rc-2";
export var details = "_rc-1";
export var dropdownContainer = "_rc-5";
export var dropdownImage = "_rc-6";
export var editAssigneeForm = "_rc-a";
export var editButton = "_rc-3";
export var email = "_rc-7";
export var hidden = "_rc-d";
export var input = "_rc-8";
export var saveButton = "_rc-b";
export var shopifyIcon = "_rc-c";
export var suggestionBadge = "_rc-e";
export var suggestionText = "_rc-f";
export var username = "_rc-9";